export default "__VITE_ASSET__DdewUIyc__"